import React from "react";
import RenderSectionTitle from "./RenderSectionTitle";
import RenderSubSectionTitle from "./RenderSubSectionTitle";
import _ from "lodash";
import {
  getEntitiesFor,
  groupEntitiesBySubsection,
  getSubsectionsOf,
} from "./DataFlowHelper";

function getSubSectionStyle(relevantEntities) {
  return {
    width: `${
      relevantEntities[0].subsectionName === "CASE_HISTORY" ? "90vw" : "47vw"
    }`,
    marginRight: "10px",
  };
}

// function getSubSectionName(
//   subSectionsInfoList,
//   subSectionName,
//   namingConvention
// ) {
//   let whichSubsection = _.find(
//     subSectionsInfoList,
//     (y) => y.subsectionName === subSectionName
//   );

//   return getAlteredName(
//     whichSubsection.subsectionNiceName.toUpperCase(),
//     namingConvention
//   );
// }

function fixMedicineInsn(i) {
  if (!i) return "";
  i = i.replace("once", "one time");
  i = i.replace("twice", "two times");
  i = i.replace("thrice", "three times");
  return i;
}

function HistorySection({
  entities,
  sectionMaps,
  subSectionMaps,
  styleOptions,
  showSubSectionTitle,
}) {
  const sectionEntities = getEntitiesFor(entities, "HISTORY");
  if (sectionEntities.length === 0) return null;
  const HISTORY_SubSectionList = getSubsectionsOf("HISTORY");
  const groupedEntities = groupEntitiesBySubsection(
    sectionEntities,
    HISTORY_SubSectionList
  );
  const sectionTitleRender = sectionMaps["HISTORY"];
  return (
    <div>
      {showSubSectionTitle ? (
        <RenderSectionTitle text={sectionTitleRender} />
      ) : null}
      <div style={styleOptions.mainContainerStyle}>
        {groupedEntities.map((subsection) => {
          let relevantEntities = subsection.entities;
          if (!relevantEntities.length) return null;
          const subsectionTitleRender =
            subSectionMaps["HISTORY"][subsection.subsectionName];
          return (
            <div style={getSubSectionStyle(relevantEntities)}>
              <RenderSubSectionTitle text={subsectionTitleRender} />
              {relevantEntities.map((each, index) => {
                let elements = [];
                let firstLine = [];

                firstLine.push(<>- </>);

                if (each.laterality) {
                  if (each.laterality === "LEFT") {
                    firstLine.push(<b>LE - </b>);
                  } else if (each.laterality === "RIGHT") {
                    firstLine.push(<b>RE - </b>);
                  } else {
                    firstLine.push(<b>BE - </b>);
                  }
                }

                if (each.subsectionName === "ALLERGY") {
                  firstLine.pop();
                  firstLine.push(
                    <div
                      style={{
                        backgroundColor: "#E6E7E7",
                        width: "fit-content",
                        fontSize: "larger",
                      }}
                    >
                      <b>- {each.entityName}</b>
                    </div>
                  );
                } else {
                  firstLine.push(<>{each.entityName}</>);
                }
                if (each.notes) {
                  firstLine.push(<> ({each.notes})</>);
                }
                if (each.molecule) {
                  elements.push(<> ({each.molecule}) </>);
                }
                if (each.instructions) {
                  let text = <></>;
                  if (each.subsectionName === "MEDICATIONS") {
                    let t = each.instructions.split(";");
                    t = t.map((each) => each.split(","));
                    t = _.flatten(t);
                    t = t.map((each) => _.upperFirst(each.trim()));
                    text = (
                      <>
                        {t.map((each) => {
                          return <div>{fixMedicineInsn(each)}</div>;
                        })}
                      </>
                    );
                  } else {
                    text = each.instructions
                      .split(",")
                      .map((each) => _.upperFirst(each.trim()))
                      .map((f) => <div>{f}</div>);
                  }
                  elements.push(
                    <div style={styleOptions.subSectionTitleStyle}>{text}</div>
                  );
                }

                if (each.anaesthesia) {
                  let niceStrings = {
                    TOPICAL_ANAESTHESIA: "TA",
                    LOCAL_ANAESTHESIA: "LA",
                    REGIONAL_ANAESTHESIA: "RA",
                    GENERAL_ANAESTHESIA: "GA",
                  };
                  elements.push(<>↓: {niceStrings[each.anaesthesia]} </>);
                }
                if (each.sxLinkedInvestigations) {
                  let niceStrings = {
                    BIOMETRY_OCT_SPECULAR: "Biometry, OCT and Specular",
                    BIOMETRY_OCT_SYRINGING_SPECULAR:
                      "Biometry, OCT, Syringing and Specular",
                    OCT_DFP: "OCT and DFP",
                    "ECG_X-RAY_PPBS": "ECG, X-Ray and PPBS",
                  };
                  elements.push(" | Pre-Surgery Investigations: ");
                  elements.push(niceStrings[each.sxLinkedInvestigations]);
                  if (each.notes) {
                    elements.push(` (${each.notes})`);
                  }
                }

                return (
                  <div style={styleOptions.subSectionBulletPoint}>
                    <div>
                      {firstLine.map((each) => {
                        return <>{each}</>;
                      })}
                    </div>

                    {elements.map((each) => (
                      <div>{each}</div>
                    ))}
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default HistorySection;
